import React, { useCallback, useRef } from 'react'
import { connect } from 'react-redux'
import styled, { css } from 'styled-components'
import config from 'constants/config'
import zIndex from 'styles/tools/z-index'
import { useAppDispatch } from 'hooks/reduxHooks'
import { goBack } from 'connected-react-router'
import { useHeaderStateObserver } from 'contexts/HeaderStateContext'
import { getCruiseItems } from 'checkout/selectors/view/cruise'
import CommonHeaderCheckout from './CommonHeaderCheckout'
import StepsHeaderCheckout from './StepsHeaderCheckout/StepsHeaderCheckout'
import AnalyticsPageContext, { AnalyticsPage } from 'contexts/Analytics/analyticsPageContext'
import { getTourCheckoutSteps } from 'components/App/Header/HeaderCheckout/StepsHeaderCheckout/steps/tours'
import LayoutContainer from 'components/Common/LayoutContainer'
import { useElementHeight } from 'hooks/useElementSize'
import CheckoutSubheader from 'checkout/Components/Shared/Headers/CheckoutSubheader'

const StickyContainer = styled.header`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid ${props => props.theme.palette.neutral.default.five};
  z-index: ${zIndex.stickyHeader};
  background-color: ${props => props.theme.palette.neutral.default.eight};

  ${() => !config.WL_USES_GLOBAL_STYLING && config.header.backgroundColor && css`
    background: ${config.header.backgroundColor};
    color: ${props => props.theme.palette.neutral.default.eight};
  `}

  ${() => !config.WL_USES_GLOBAL_STYLING && config.header.backgroundGradientColor && css`
    background: linear-gradient(90deg, ${config.header.backgroundColor}, ${config.header.backgroundGradientColor});
  `}
`

interface Props {
  isCruise: boolean
  hasTourCheckoutSteps: boolean
}

function HeaderCheckout(props: Props) {
  const { isCruise, hasTourCheckoutSteps } = props

  const dispatch = useAppDispatch()
  const handleGoBack = useCallback(() => {
    dispatch(goBack())
  }, [dispatch])
  const headerRef = useRef<HTMLElement>(null)
  const headerHeight = useElementHeight(headerRef)
  useHeaderStateObserver('checkout', headerRef)

  const hasSteps = isCruise || hasTourCheckoutSteps

  return (
    <AnalyticsPageContext.Provider value={AnalyticsPage.checkout}>
      <StickyContainer data-testid="checkout-header" ref={headerRef}>
        <LayoutContainer size="xl">
          {!hasSteps && <CommonHeaderCheckout onBack={handleGoBack} />}
          {hasSteps && <StepsHeaderCheckout onBack={handleGoBack} />}
        </LayoutContainer>
      </StickyContainer>
      <CheckoutSubheader topOffset={headerHeight ?? 0} />
    </AnalyticsPageContext.Provider>
  )
}

const mapStateToProps = (state: App.State) => ({
  isCruise: getCruiseItems(state).length > 0,
  hasTourCheckoutSteps: getTourCheckoutSteps(state).length > 1,
})

export default connect(mapStateToProps)(HeaderCheckout)
